module.exports = __webpack_public_path__ + "img/onelinc-logo-v4-horizontal-vect.f4899cb5.svg";